module.exports = __webpack_public_path__ + "static/media/Cup_Box.b3a04d33.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Cup_Box.png
// module id = 1695
// module chunks = 0